function trapFocus(modal, { focusDelay = 0 } = {}) {
  const selector = `a[href], area[href], input:not([disabled]),
    select:not([disabled]), textarea:not([disabled]),
    button:not([disabled]), [tabindex]:not([tabindex="-1"])`;
  const focusable = Array.from(modal.querySelectorAll(selector));
  if (!focusable.length) return;

  const first = focusable[0];
  const last  = focusable[focusable.length - 1];

  function handleFocusTrap(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === first) { last.focus(); e.preventDefault(); }
    } else {
      if (document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  }

  modal.addEventListener('keydown', handleFocusTrap);
  if (keyboardUser && !modal.contains(document.activeElement)) {
    if (focusDelay > 0) {
      setTimeout(() => first.focus(), focusDelay);
    } else {
      first.focus();
    }
  }

  return () => modal.removeEventListener('keydown', handleFocusTrap);
}

// Tooltip
(() => {
  function positionTooltip(popup, trigger) {
    const maxWidth    = Math.min(256, window.innerWidth - 32);
    popup.style.maxWidth = maxWidth + 'px';

    const popupWidth  = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;
    const triggerRect = trigger.getBoundingClientRect();
    const centerX     = triggerRect.left + triggerRect.width / 2;
    const top         = triggerRect.top + window.scrollY - popupHeight - 8;
    const desiredLeft = centerX - popupWidth / 2;
    const left        = Math.max(16, Math.min(desiredLeft, window.innerWidth - 16 - popupWidth));

    popup.style.top  = top + 'px';
    popup.style.left = left + 'px';
  }

  function triggerTooltip(trigger) {
    const existing = document.querySelector('[data-tooltip-popup]');
    if (existing) { existing.remove(); return; } // toggle off if same tooltip open
    const id      = trigger.dataset.tooltip;
    const content = document.querySelector(`template[data-tooltip-content="${id}"]`)?.innerHTML;
    if (!content) return;

    const popup = document.createElement('div');
    popup.dataset.tooltipPopup = '';
    popup.innerHTML = content;
    popup.style.position = 'absolute';
    document.body.appendChild(popup);
    positionTooltip(popup, trigger);

    trigger.addEventListener('blur', () => popup.remove(), { once: true });
  }

  document.addEventListener('click', e => {
    if (!e.target?.closest) return;
    const trigger = e.target.closest('[data-tooltip]');
    if (trigger) { e.stopPropagation(); e.preventDefault(); triggerTooltip(trigger); return; }
    document.querySelectorAll('[data-tooltip-popup]').forEach(p => p.remove());
  }, true);
})();


document.addEventListener('click', e => {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const id = a.getAttribute('href').slice(1);
  if (!id) return;
  const target = document.getElementById(id);
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

// ── Generic Swiper loop init ─────────────────────────────────────────────────
// Add init="false" data-swiper-loop to any swiper-container to opt in.
// Parses HTML attributes into typed JS params (mirrors bluestar globals.js pattern)
// so booleans and JSON are set correctly before initialize().
(function () {
  var attrMap = {
    'slides-per-view':      ['slidesPerView',      parseFloat],
    'space-between':        ['spaceBetween',        parseInt],
    'grab-cursor':          ['grabCursor',          function (v) { return v !== 'false'; }],
    'loop':                 ['loop',                function (v) { return v !== 'false'; }],
    'centered-slides':      ['centeredSlides',      function (v) { return v !== 'false'; }],
    'slides-offset-before': ['slidesOffsetBefore',  parseInt],
    'initial-slide':        ['initialSlide',        parseInt],
  };

  function initSwiperLoop(root) {
    var els = (root || document).querySelectorAll('[data-swiper-loop]:not([data-swiper-ready])');
    if (!els.length) return;
    els.forEach(function (el) { el.dataset.swiperReady = '1'; });

    // swiper-element-bundle loads async, so it may not have registered the
    // custom element yet (and el.initialize wouldn't exist) — wait for it.
    customElements.whenDefined('swiper-container').then(function () {
      els.forEach(function (el) {
        var options = {};
        for (var attr in attrMap) {
          if (el.hasAttribute(attr)) {
            var cfg = attrMap[attr];
            options[cfg[0]] = cfg[1](el.getAttribute(attr));
          }
        }

        var bp = el.getAttribute('breakpoints');
        if (bp) { try { options.breakpoints = JSON.parse(bp); } catch (e) {} }

        var is = el.getAttribute('inject-styles');
        if (is) { try { options.injectStyles = JSON.parse(is); } catch (e) {} }

        options.a11y = false;
        options.keyboard = { enabled: true, onlyInViewport: false };
        Object.assign(el, options);
        el.initialize();

        requestAnimationFrame(function () {
          if (!el.swiper) return;
          el.swiper.slideToLoop(options.initialSlide || 0, 0);

          // Focus on any link/button inside a slide → scroll swiper to that slide (handles clones)
          el.querySelectorAll('swiper-slide a, swiper-slide button').forEach(function (focusable) {
            focusable.addEventListener('focus', function () {
              var slide = focusable.closest('swiper-slide');
              if (!slide) return;
              var idx = parseInt(slide.dataset.swiperSlideIndex, 10);
              if (!isNaN(idx)) el.swiper.slideToLoop(idx, 300);
            });
          });

          // Arrow keys → navigate slides → focus first focusable in new active slide
          el.swiper.on('keyPress', function (swiper, keyCode) {
            if (keyCode !== 37 && keyCode !== 39) return;
            el.swiper.once('slideChangeTransitionEnd', function () {
              var activeSlide = el.swiper.slides[el.swiper.activeIndex];
              if (!activeSlide) return;
              var first = activeSlide.querySelector('a, button');
              if (first) first.focus({ preventScroll: true });
            });
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSwiperLoop(); });
  } else {
    initSwiperLoop();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initSwiperLoop(e.target);
  });

  // intersection-loader swaps its children into the DOM then removes itself,
  // so e.detail has no parentElement by dispatch time — rescan the document.
  document.addEventListener('intersection:loaded', function () {
    initSwiperLoop();
  });
})();

